<template>
  <div>
    <el-row v-if="!$route.params.type || !bundleId" class="choose-app" :gutter="15">
      <el-col
        v-for="(item, key) in bundles"
        class="align-center"
        :key="key"
        :span="5"
      >
        <el-button
          type="default"
          v-bind:class="{ [key]: true, app: true, disabled: item.disabled, selected: bundleId === key }"
          @click="$emit('update:bundleId', (item.disabled ? null : key))"
        >
          {{ item.name }}
        </el-button>
      </el-col>
    </el-row>

    <InstanceBundle
      v-if="bundleId"
      class="bundle-config"
      shadow="always"
      :bundle-id="bundleId"
      :version.sync="form.version"
      :pkg-version.sync="form.pkgVersion"
    />
  </div>
</template>

<script>
import InstanceBundle from '../Instance/Bundle'
import _ from 'lodash'

export default {
  props: {
    bundleId: String,
    version: String,
    pkgVersion: String
  },
  components: {
    InstanceBundle
  },
  data () {
    return {
      form: {
        version: null,
        pkgVersion: null
      }
    }
  },
  computed: {
    bundles () {
      return _.omitBy(this.$root.bundles, (b) => b.database || b.disabled)
    }
  },
  watch: {
    form: {
      handler (value) {
        this.$emit('update:version', value.version)
        this.$emit('update:pkgVersion', value.pkgVersion)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .app {
    background-position: center left 16px;
    background-repeat: no-repeat;
    background-size: 25px;
    padding-left: 50px;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    color: $--color-text-primary;
    border-color: $--border-color-base;
    width: 100%;
    margin: 10px 0 0;

    &.selected {
      border: 1px solid $--color-primary;
      box-shadow: $--card-box-shadow-small !important;
    }
  }
</style>
